'use client';

import { AppButton } from '@/components/design/forms';
import { CheckCircle2, Info, X } from 'lucide-react';
import { useState } from 'react';
import { useTranslations } from 'next-intl';

/** Зелёная плашка: автосохранение черновика в браузере (гость, registration-flow). */
export function AutoSaveIndicator() {
  const t = useTranslations('strings.registrationFlow');

  return (
    <div
      className="mb-6 animate-fade-in rounded-2xl border-2 border-fest-apple-green bg-gradient-to-r from-fest-apple-green to-fest-green p-5 shadow-md"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start gap-4">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-white/20 backdrop-blur-sm">
          <CheckCircle2 className="h-5 w-5 text-white" aria-hidden />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="mb-1 text-lg font-bold text-white">{t('autoSaveTitle')}</h3>
          <p className="text-sm leading-relaxed text-white/90">{t('autoSaveDescription')}</p>
        </div>
      </div>
    </div>
  );
}

function SavedDataBanner() {
  const t = useTranslations('strings.registrationFlow');
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="mb-6 animate-fade-in rounded-xl border-2 border-fest-apple-green bg-gradient-to-r from-fest-apple-green to-fest-green p-4 shadow-md">
      <div className="flex items-start gap-3">
        <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-white/20 backdrop-blur-md">
          <Info className="h-5 w-5 text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <h4 className="mb-1 text-base font-bold text-white">{t('savedDataTitle')}</h4>
          <p className="text-sm text-white/90">{t('savedDataDescription')}</p>
        </div>
        <AppButton
          type="button"
          onClick={() => setIsVisible(false)}
          className="text-white/80 transition-colors hover:text-white"
          aria-label={t('savedDataDismissAria')}
        >
          <X className="h-5 w-5" />
        </AppButton>
      </div>
    </div>
  );
}
